const havePermission = function (permissions) {
    if (!permissions) return false
    const perms = JSON.parse(window.localStorage.permissions);
    if (!perms) return false;
    return perms.filter(p => permissions.includes(p.value)).length > 0
}

export {
    havePermission
}
